import { useReducer } from 'react';
import { Details, File, FormMarkup } from '@components/basicComponents';
import { getSortedFormFields, handleFormSubmit } from '@utils/forms';
import type { FormExtendedEvent } from 'grommet/components/Form';
import type { FormProps } from '@customTypes/types';
import type { BlankRequestGLCPFormState } from '@customTypes/stateTypes';

const formTitle: string = 'HPE GreenLake Support';

export const BlankRequestGLCPForm = (props: FormProps): JSX.Element => {
  const [state, updateState] = useReducer(
    (prev: BlankRequestGLCPFormState, newState: Partial<BlankRequestGLCPFormState>) => ({
      ...prev,
      ...newState,
    }),
    {
      numFiles: 0,
    }
  );

  const onFileChange = (value: number): void => {
    updateState({ numFiles: value });
  };

  const onSubmit = ({ target }: FormExtendedEvent): void => {
    let namespace: string = 'hpe_blank';
    let subject: string = 'Blank : {formId}';
    const data = getSortedFormFields(target, namespace, subject);

    handleFormSubmit(data, props.onSuccess, props.onError, props.onLoading);
  };

  const onReset = (): void => {
    updateState({ numFiles: 0 });
  };

  return (
    <FormMarkup
      onSubmit={onSubmit}
      onReset={onReset}
      formTitle={formTitle}
      doubleFieldPhone
      formFields={
        <>
          <Details />

          <File numFiles={state.numFiles} onFileChange={onFileChange} />
        </>
      }
    />
  );
};
